var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronleftcompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5801 19.9277C12.6973 20.2207 12.9512 20.3867 13.2051 20.3867C13.6348 20.3867 13.957 20.0742 13.957 19.6543C13.957 19.4297 13.8398 19.1562 13.7715 18.9609L10.9688 11.9297L13.7715 4.9082C13.8398 4.71289 13.957 4.42969 13.957 4.21484C13.957 3.79492 13.6348 3.48242 13.2051 3.48242C12.9512 3.48242 12.6973 3.64844 12.5801 3.94141L9.81641 10.875C9.68945 11.1973 9.5332 11.6172 9.5332 11.9297C9.5332 12.252 9.68945 12.6621 9.81641 12.9941L12.5801 19.9277Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronleftcompact);
export default __webpack_public_path__ + "static/media/Chevron left compact.2db41dd59e68d3e3fac405db54cf898b.svg";
export { ForwardRef as ReactComponent };